import React from "react"
import { Switch, Redirect } from "react-router-dom";
import { ContentRoute } from "../../../../../../../_metronic/layout";
import { Permissions } from "../../../../../../util/Permissions";
import UserLayout from "../user-layout/UserLayout";
import Activities from "./activities/Activities";
import AccountInformation from "./account-information/AccountInformation";
import BankAccounts from "./bank-accounts/BankAccounts";
import Compliance from "./compliance/Compliance";
import Documents from "./documents/Documents";
import ProfileDetail from "./profile-detail/ProfileDetail";
import Referrals from "./promotions/Referrals";
import ReferralBonuses from "./promotions/ReferralBonuses";
import SavedCards from "./saved-cards/SavedCards";
import Cards from "./trove-cards/Cards";
import Subscriptions from "./subscriptions/Subscriptions";
import Social from "./social/Social";
import GiftCards from "./gift-cards/GiftCards";
import SafeLocks from "./safe-locks/SafeLocks";
import Liquidations from "./safe-locks/Liquidations";
import Gems from "./gems/Gems";
import SecurityQuestions from "./security-questions/SecurityQuestions";
import Pin from "./pin/Pin";

const UserPages = props => {
    return (
        <UserLayout {...props} >
            <Switch>
                <ContentRoute path="/users/view/:userId/profile-detail" permission={Permissions.PROFILE} component={ProfileDetail} />
                <ContentRoute path="/users/view/:userId/activities" permission={Permissions.TRANSACTIONS} component={Activities} />
                <ContentRoute path="/users/view/:userId/promotions/referrals/:referralCode" permission={Permissions.REFERRALS} component={Referrals} />
                <ContentRoute path="/users/view/:userId/promotions/referral-bonuses/:referralCode" permission={Permissions.REFERRALS} component={ReferralBonuses} />
                <ContentRoute path="/users/view/:userId/account-information/:accountId" permission={Permissions.ACCOUNTS} component={AccountInformation} />
                <ContentRoute path="/users/view/:userId/bank-accounts" permission={Permissions.BANK_ACCOUNTS} component={BankAccounts} />
                <ContentRoute path="/users/view/:userId/cards" permission={Permissions.CARDS} component={Cards} />
                <ContentRoute path="/users/view/:userId/subscriptions" permission={Permissions.SUBSCRIPTIONS} component={Subscriptions} />
                <ContentRoute path="/users/view/:userId/social" permission={Permissions.SOCIAL} component={Social} />
                <ContentRoute path="/users/view/:userId/gift-cards" permission={Permissions.GIFT_CARDS} component={GiftCards} />
                <ContentRoute path="/users/view/:userId/gems" permission={Permissions.GEMS} component={Gems} />
                <ContentRoute path="/users/view/:userId/saved-cards" permission={Permissions.SAVED_CARDS} component={SavedCards} />
                <ContentRoute path="/users/view/:userId/documents" permission={Permissions.DOCUMENTS} component={Documents} />
                <ContentRoute path="/users/view/:userId/safe-lock" permission={Permissions.SAFE_LOCK} component={SafeLocks} />
                <ContentRoute path="/users/view/:userId/liquidations" permission={Permissions.SAFE_LOCK} component={Liquidations} />
                <ContentRoute path="/users/view/:userId/compliance" component={Compliance} />
                <ContentRoute path="/users/view/:userId/security-questions" permission={Permissions.SECURITY_QUESTIONS} component={SecurityQuestions} />
                <ContentRoute path="/users/view/:userId/pin" permission={Permissions.PROFILE} component={Pin} />

                <Redirect from="/users/view/:userId" to="/users/view/:userId/profile-detail"/>
            </Switch>
        </UserLayout>
    )

}

export default UserPages;
